import { render, staticRenderFns } from "./FixedExpensePaymentPeriodTypeSelect.vue?vue&type=template&id=506248ec&scoped=true&"
import script from "./FixedExpensePaymentPeriodTypeSelect.vue?vue&type=script&lang=js&"
export * from "./FixedExpensePaymentPeriodTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506248ec",
  null
  
)

export default component.exports